import config from '../../static/config/config.json';

import axios from 'axios'
import util from '@/utils/utils.js'

//import qs from 'qs'

axios.defaults.baseURL = 'http://' + config.adminserver.address + ':' + config.adminserver.port + '/' + config.adminserver.content + '/';
//request 钩子
axios.interceptors.request.use(con => {
    return con
}, error => {
    return Promise.reject(error)
})

//response 钩子
axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error)
})

//返回状态判断
function checkStatus(response) {
    if (!response.status) {
        return {
            code: '501',
            meta: {
                success: false,
                message: '发生网络错误，请检查网络配置或尝试重新登'
            },
            error: response.statusText
        }
    }

    if (response.status === 200 || response.status === 304) {
        if (util.isJson(response.data)) return JSON.parse(response.data)
        let result = response.data
        if (result.data && util.isJson(result.data)) {
            result.data = JSON.parse(result.data)
            let keys = Object.keys(result.data)
            if (keys.length) {
                for (let i = 0, len = keys.length; i < len; i++) {
                    if (!Number.isInteger(Number(result.data[keys[i]])) && util.isJson(result.data[keys[i]])) {
                        result.data[keys[i]] = JSON.parse(result.data[keys[i]])
                    }
                }
            }
        }
        return result;
    }

    return {
        code: response.status,
        meta: {
            success: false,
            message: response.statusText
        }
    }
}

export default {
    post(url, data) {
        return new Promise((resolve, reject) => {
            let str = `${config.sName}&${new Date().getTime()}`
            let token = util.encrypt(str)
            axios({
                method: 'post',
                url: axios.defaults.baseURL + url,
                data: data,
                timeout: 30000,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'Auth-Token': token
                }
            })
                .then(res => checkStatus(res))
                // 最后一个then 启用 resolve,reject
                .then(res => resolve(res))
                .catch(err => {
                    reject(err)
                })
        })
    },
    get(url, params) {
        return new Promise((resolve, reject) => {
            let str = `${config.sName}&${new Date().getTime()}`
            let token = util.encrypt(str)
            axios({
                method: 'get',
                url: axios.defaults.baseURL + url,
                params,
                timeout: 30000,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'Auth-Token': token
                }
            })
                .then(res => checkStatus(res))
                .then(res => resolve(res))
                .catch(err => {
                    reject(err)
                })
        })
    },
    checkLogin(url, params = {}) {
        return new Promise((resolve, reject) => {
            var loginToken = localStorage.getItem("loginToken")
            let str = `${config.sName}&${new Date().getTime()}`
            let token = util.encrypt(str)
            axios({
                method: 'get',
                url: axios.defaults.baseURL + url,
                params,
                timeout: 30000,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'Auth-Token': token,
                    'LoginToken': loginToken
                }
            }).then(res => checkStatus(res))
                .then(res => resolve(res))
                .catch(err => {
                    reject(err)
                })
        })
    }
}
